/**
 * @flow
 * @relayHash 6f87855a1e8fb025e3fb5182ea3564e7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getSuborgDetailsQueryVariables = {|
  id?: ?string
|};
export type getSuborgDetailsQueryResponse = {|
  +authorizedSuborgs: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +region: ?string,
    +address: ?any,
    +propertyLogoUrl: ?string,
    +propertyManagerLogoUrl: ?string,
    +timezone: ?string,
    +timezoneOffset: ?string,
    +timezoneAbbr: ?string,
    +org: {|
      +id: string,
      +name: string,
      +hyeventsSetting: {|
        +approverEmails: $ReadOnlyArray<string>
      |},
    |},
    +linkColor: ?string,
    +fontFamily: ?string,
    +textColor: ?string,
    +buttonBorderColor: ?string,
    +buttonFontColor: ?string,
    +buttonBackgroundColor: ?string,
    +hyeventsSetting: ?{|
      +approverEmails: $ReadOnlyArray<string>
    |},
  |}>
|};
export type getSuborgDetailsQuery = {|
  variables: getSuborgDetailsQueryVariables,
  response: getSuborgDetailsQueryResponse,
|};
*/


/*
query getSuborgDetailsQuery(
  $id: String
) {
  authorizedSuborgs(orgId: "any", first: 1, propertyId: $id) {
    id
    name
    region
    address
    propertyLogoUrl
    propertyManagerLogoUrl
    timezone
    timezoneOffset
    timezoneAbbr
    org {
      id
      name
      hyeventsSetting {
        approverEmails
        id
      }
    }
    linkColor
    fontFamily
    textColor
    buttonBorderColor
    buttonFontColor
    buttonBackgroundColor
    hyeventsSetting {
      approverEmails
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Literal",
    "name": "orgId",
    "value": "any"
  },
  {
    "kind": "Variable",
    "name": "propertyId",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "region",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "propertyLogoUrl",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "propertyManagerLogoUrl",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timezone",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timezoneOffset",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timezoneAbbr",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approverEmails",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "hyeventsSetting",
  "storageKey": null,
  "args": null,
  "concreteType": "HyeventsSetting",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkColor",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fontFamily",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "textColor",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buttonBorderColor",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buttonFontColor",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buttonBackgroundColor",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "hyeventsSetting",
  "storageKey": null,
  "args": null,
  "concreteType": "HyeventsSetting",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v2/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getSuborgDetailsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedSuborgs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Suborg",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "org",
            "storageKey": null,
            "args": null,
            "concreteType": "Org",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v12/*: any*/)
            ]
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v12/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "getSuborgDetailsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "authorizedSuborgs",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Suborg",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "org",
            "storageKey": null,
            "args": null,
            "concreteType": "Org",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v19/*: any*/)
            ]
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "getSuborgDetailsQuery",
    "id": null,
    "text": "query getSuborgDetailsQuery(\n  $id: String\n) {\n  authorizedSuborgs(orgId: \"any\", first: 1, propertyId: $id) {\n    id\n    name\n    region\n    address\n    propertyLogoUrl\n    propertyManagerLogoUrl\n    timezone\n    timezoneOffset\n    timezoneAbbr\n    org {\n      id\n      name\n      hyeventsSetting {\n        approverEmails\n        id\n      }\n    }\n    linkColor\n    fontFamily\n    textColor\n    buttonBorderColor\n    buttonFontColor\n    buttonBackgroundColor\n    hyeventsSetting {\n      approverEmails\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2a578eda44650cc2d5a90b24627e5306';
module.exports = node;
